/**
 * @fileoverview Dashboard API Module
 */

import api from "./api";

/**
 * Helper to handle API requests consistently
 */
const handleRequest = async (request) => {
  try {
    const response = await request;
    return response.data;
  } catch (error) {
    console.error("API Request failed:", error);
    return null;
  }
};
const exportAllDashboardDatas = async (params = {}) => {
  try {
    const response = await api.get("/api/dashboard/export-all", {
      params,
      responseType: "blob",
      headers: {
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream",
      },
    });
    return response.data;
  } catch (error) {
    return `exportAllDashboardData failed: ${error.message}`;
  }
};
const DEFAULT_PARAMS = {
  carrierCodes: [],
  groupNumbers: [],
  startDate: "",
  endDate: "",
};

const dashboardApi = {
  /**
   * Retrieves outreach outcomes statistics (POST)
   */
  getOutreachOutcomes: (data = DEFAULT_PARAMS) =>
    handleRequest(api.post("/member-dashboard/outreach-outcomes", data)),

  /**
   * Retrieves care guide performance report (POST)
   */
  getCareGuidePerformance: () =>
    handleRequest(api.post("/member-dashboard/care-guide-performance", {})),

  /**
   * Retrieves member opportunity outcomes (POST)
   */
  getMemberOpportunityOutcomes: (data = DEFAULT_PARAMS) =>
    handleRequest(
      api.post("/member-dashboard/member-opportunity-outcomes", data),
    ),

  /**
   * Retrieves program performance overview (POST)
   */
  getProgramPerformances: (data = DEFAULT_PARAMS) =>
    handleRequest(api.post("/member-dashboard/program-performances", data)),
};
dashboardApi.exportAllDashboardData = exportAllDashboardDatas;
export default dashboardApi;
